export default "__VITE_ASSET__FT4opV3G__"